import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import Success from '@Images/admin/success.png';
import './style.scss';

/**
 *
 */
function UnicommerceSuccess({ history }) {
  return (
    <div className="integration-success__wrapper">
      <div className="integration-success-action-wrapper__align">
        <img
          src={Success}
          alt="success "
          width="70px"
          height="70px"
          style={{
            marginBottom: '12px',
            marginTop: '10px',
          }}
        />
        <p className="integration-success-heading">Your Unicommerce account is now connected to Procuzy!</p>
        <p className="integration-success-subheading">Your order and stock levels will get synced with Unicommers as per the selected configuration.</p>

        <div style={{ marginTop: '20px' }}>
          <Button
            type="primary"
            onClick={() => history.push('/admin/integration/')}
          >
            Back to Integrations
          </Button>
        </div>
      </div>
    </div>
  );
}

const mapStateToProps = () => ({

});
const mapDispatchToProps = () => ({

});
UnicommerceSuccess.propTypes = {
  history: PropTypes.any,

};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UnicommerceSuccess));
